import { Injectable, Injector } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
} from "@angular/common/http";
import { map, Observable } from "rxjs";
import { finalize, tap } from "rxjs/operators";
import { LoaderService } from "src/app/Services/LoaderService/loader.service";

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  showLoaderCustom: any[] = [];
  loaderInterval: any = null;

  constructor(private injector: Injector) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const loaderService = this.injector.get(LoaderService);
    if (request.params.get("keyword") || request.params.get("Keyword")) {
      loaderService.hide();
    } else {
      loaderService.show();
    }
    this.showLoaderCustom.push(request);

    // this.loaderInterval = setInterval(() => {
    //   if (this.showLoaderCustom.length <= 0) loaderService.hide();
    // }, 1000);

    return next.handle(request).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            this.showLoaderCustom.pop();
            if (this.showLoaderCustom.length == 0) {
              loaderService.hide();
            }
          }
          // console.log(this.showLoaderCustom);
        },
        (err: any) => {
          this.showLoaderCustom.pop();
          if (this.showLoaderCustom.length == 0) {
            loaderService.hide();
          }
          // console.log(this.showLoaderCustom);
        }
      )
    );
  }
}
